import React from 'react';
import { MapPin, Gift, ShoppingBag, ChevronRight } from 'lucide-react';
import { Store, Order, UserProfile } from '../../types';
import { StoreCard } from '../StoreCard';
import { STORES } from '../../data/mockData';
interface HomeScreenProps {
  user: UserProfile;
  onNavigate: (screen: any) => void;
  onStoreClick: (store: Store) => void;
}
export function HomeScreen({
  user,
  onNavigate,
  onStoreClick
}: HomeScreenProps) {
  const nearbyStores = STORES.slice(0, 4);
  const featuredStore = STORES[0];
  return <div className="pb-24 pt-6 px-4 space-y-8 animate-in fade-in duration-500" data-id="element-459">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-460">
        <div data-id="element-461">
          <p className="text-gray-500 text-sm font-medium" data-id="element-462">Good Morning,</p>
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-463">
            {user.name.split(' ')[0]}! 👋
          </h1>
        </div>
        <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden border-2 border-white shadow-sm" data-id="element-464">
          <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" data-id="element-465" />
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-3 gap-3" data-id="element-466">
        <button onClick={() => onNavigate('explore')} className="flex flex-col items-center justify-center p-4 bg-purple-50 rounded-2xl active:scale-95 transition-transform" data-id="element-467">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 mb-2" data-id="element-468">
            <MapPin size={20} data-id="element-469" />
          </div>
          <span className="text-xs font-bold text-purple-900" data-id="element-470">Explore</span>
        </button>
        <button onClick={() => onNavigate('gifting')} className="flex flex-col items-center justify-center p-4 bg-yellow-50 rounded-2xl active:scale-95 transition-transform" data-id="element-471">
          <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-700 mb-2" data-id="element-472">
            <Gift size={20} data-id="element-473" />
          </div>
          <span className="text-xs font-bold text-yellow-900" data-id="element-474">Send Gift</span>
        </button>
        <button onClick={() => onNavigate('orders')} className="flex flex-col items-center justify-center p-4 bg-green-50 rounded-2xl active:scale-95 transition-transform" data-id="element-475">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-2" data-id="element-476">
            <ShoppingBag size={20} data-id="element-477" />
          </div>
          <span className="text-xs font-bold text-green-900" data-id="element-478">Orders</span>
        </button>
      </div>

      {/* Nearby Favorites */}
      <div data-id="element-479">
        <div className="flex justify-between items-center mb-4" data-id="element-480">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-481">Nearby Favorites</h2>
          <button onClick={() => onNavigate('explore')} className="text-sm text-purple-600 font-semibold flex items-center" data-id="element-482">
            See All <ChevronRight size={16} data-id="element-483" />
          </button>
        </div>
        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide" data-id="element-484">
          {nearbyStores.map(store => <StoreCard key={store.id} store={store} variant="compact" onClick={() => onStoreClick(store)} data-id="element-485" />)}
        </div>
      </div>

      {/* Check In Feature */}
      <div className="bg-gradient-to-br from-[#1F1F38] to-[#2E2E52] rounded-3xl p-6 text-white relative overflow-hidden" data-id="element-486">
        <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/20 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-487" />

        <div className="relative z-10" data-id="element-488">
          <div className="flex items-start justify-between mb-6" data-id="element-489">
            <div data-id="element-490">
              <p className="text-purple-200 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-491">
                Featured Spot
              </p>
              <h3 className="text-2xl font-bold" data-id="element-492">{featuredStore.name}</h3>
            </div>
            <div className="bg-white/10 backdrop-blur-md p-2 rounded-xl" data-id="element-493">
              <MapPin className="text-[#FFFC00]" data-id="element-494" />
            </div>
          </div>

          <div className="flex items-center gap-4 mb-6" data-id="element-495">
            <img src={featuredStore.image} alt="" className="w-12 h-12 rounded-lg object-cover border border-white/10" data-id="element-496" />
            <div data-id="element-497">
              <p className="text-sm text-gray-300" data-id="element-498">Earn 2x points today</p>
              <p className="text-xs text-gray-400" data-id="element-499">
                {featuredStore.distance} away
              </p>
            </div>
          </div>

          <button onClick={() => onStoreClick(featuredStore)} className="w-full py-3 bg-[#FFFC00] text-purple-900 font-bold rounded-xl hover:bg-[#E6E300] transition-colors" data-id="element-500">
            Check In Now
          </button>
        </div>
      </div>
    </div>;
}